import clsx from 'clsx'
import { FC } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button } from 'app/components/Button/Button'
import { VideoCallIcon } from '../../atendimento-video/components/videoCallIcons'
import { ATRIBUTO_CONTROLES_PIP } from '../core/regrasSomenteVideo'

type Props = {
  isMicEnabled: boolean
  isVideoEnabled: boolean
  onToggleMic: () => void
  onToggleVideo: () => void
}

type PropsBotao = {
  ligado: boolean
  icone: VideoCallIcon
  iconeDesligado: VideoCallIcon
  rotulo: string
  onClick: () => void
}

/**
 * Desligado vai em `btn-danger` com o ícone cortado — a cor nunca é o único sinal. O rótulo diz a ação
 * ("Desligar microfone"), por isso sem `aria-pressed`, que somado a ele leria o estado duas vezes.
 */
const BotaoControle: FC<PropsBotao> = ({ ligado, icone, iconeDesligado, rotulo, onClick }) => (
  <Button
    onClick={onClick}
    ariaLabel={rotulo}
    title={rotulo}
    className={clsx('btn-icon rounded-circle shadow', ligado ? 'btn-secondary' : 'btn-danger')}
  >
    <i className={ligado ? icone : iconeDesligado} aria-hidden='true' />
  </Button>
)

/**
 * Microfone e câmera do médico na janela PiP e no mini-player (LO-829). Mesmo estado e mesmos toggles da
 * barra do player — só outra apresentação. Nasce oculto (`d-none`): na tela do atendimento a barra completa
 * já tem esses botões, e só as regras "só vídeo" (`regrasSomenteVideo`) o exibem.
 */
export const ControlesPip: FC<Props> = ({
  isMicEnabled,
  isVideoEnabled,
  onToggleMic,
  onToggleVideo,
}) => {
  const { t } = useT()

  return (
    <div
      {...{ [ATRIBUTO_CONTROLES_PIP]: '' }}
      role='group'
      aria-label={t('atendimento.chamada.controles_pip')}
      className='d-none position-absolute bottom-0 start-50 translate-middle-x mb-4 gap-3 z-index-3'
    >
      <BotaoControle
        ligado={isMicEnabled}
        icone={VideoCallIcon.Mic}
        iconeDesligado={VideoCallIcon.MicOff}
        rotulo={t(
          isMicEnabled
            ? 'atendimento.chamada.microfone_desligar'
            : 'atendimento.chamada.microfone_ligar'
        )}
        onClick={onToggleMic}
      />
      <BotaoControle
        ligado={isVideoEnabled}
        icone={VideoCallIcon.Video}
        iconeDesligado={VideoCallIcon.VideoOff}
        rotulo={t(
          isVideoEnabled
            ? 'atendimento.chamada.camera_desligar'
            : 'atendimento.chamada.camera_ligar'
        )}
        onClick={onToggleVideo}
      />
    </div>
  )
}
